var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('carousel-component'),_c('h3',[_vm._v("Nouveautés")]),_c('br'),_c('h3',[_vm._v("Promotions")]),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }